module.exports = __webpack_public_path__ + "img/51626504_L.ff196f3c.png";